module.exports = __webpack_public_path__ + "static/img/10004 (6).d744c07.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10004 (6).webp
// module id = ak64
// module chunks = 14